import PropTypes from 'prop-types';
import * as React from 'react';
import './ContentContainer.scss';

export const ContentContainer = props => {
	const { children, divide, className } = props;

	const extendedClassName = 'content-container'
        + (className ? ' ' + className : '')
        + (divide ? ' content-container-divide' : '');

	return <div className={extendedClassName}>{children}</div>;
};

ContentContainer.propsTypes = {
	className: PropTypes.string,
	divide: PropTypes.bool,
	children: PropTypes.element.isRequired
};
